<template>
<div class="modal fade" id="confirm-modal" data-bs-backdrop="static" tabindex="-1" aria-labelledby="erkModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-lg">
        <div class="modal-content">
            <div class="modal-header py-2 pe-2">
                <strong class="modal-title" id="erkModalLabel">ATTENZIONE</strong>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div v-if="isLoading">

                </div>
                <div v-else>
                    {{message}}
                </div>

                <div v-if="!isLoading" class="modal-footer">
                    <button @click="onClickOk()" type="button" class="btn btn-primary close-btn">
                        Ok
                    </button>
                    <button @click="onClickCancel()" type="button" class="btn btn-secondary close-btn">
                        Annulla
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>

let myModal = null
export default{
    props: {
        userId: Number
    },
    data(){
        return {
            isLoading: false,
            message: '',
            onClickOkHandler: null,
            onClickCancellHandler: null
        }
    },
    created(){
    },
    mounted(){
    },
    methods: {
        confirm(message, onClickOkHandler, onClickCancellHandler){
            this.message = message
            this.onClickOkHandler = onClickOkHandler,
            this.onClickCancellHandler = onClickCancellHandler

            this.toggle()
        },
        toggle(){
            if (myModal == null){
                myModal = new window.bootstrap.Modal(document.getElementById('confirm-modal'))
            }
            myModal.toggle()
        },
        onClickOk(){
            if (this.onClickOkHandler){
                this.onClickOkHandler()
            }
            this.toggle()
        },
        onClickCancel(){
            if (this.onClickCancellHandler){
                this.onClickCancellHandler()
            }
            this.toggle()
        }
    }
}
</script>